import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { makeStyles, Grid, Snackbar } from "@material-ui/core";
import { Input, Dropdown, Button, Checkbox, Progress, message } from 'antd'
import { MinusOutlined, PlusOutlined, CustomerServiceOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons'
import { Document, Page, pdfjs } from 'react-pdf';
import { CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, SwapOutlined } from '@ant-design/icons'
import Modal from "@mui/material/Modal";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js`;

import TranslateModal from "../common/TranslateModal";

import axios from "axios";
import {
  createOrder,
  getFileStatus
} from '../../actions/index'

const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 60px)',
    padding: '20px',
    background: '#f6f6f6'
  },
  main: {
    width: '100%',
    height: '100%',
    background: '#fff',
    borderRadius: '16px',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '20px 0'
  },
  leftBox: {
    borderRight: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  rightBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  progress: {
    position: 'absolute',
    left: '50%',
    top: '320px',
    zIndex: '100',
    width: '70px',
    height: '70px',
    marginLeft: '-35px',
    padding: '5px',
    borderRadius: '4px',
    background: '#fff',
  },
  pdfBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pdfMain: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    '& canvas': {
      margin: '0 auto'
    }
  },
  toolbar: {
    position: 'fixed',
    left: '50%',
    bottom: '60px',
    width: '90vw',
    maxWidth: '800px',
    height: '60px',
    borderRadius: '12px',
    padding: '10px 20px',
    background: '#f6f6f6',
    border: '1px solid #ddd',
    transform: 'translateX(-50%)',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.hide': {
      bottom: '-60px'
    }
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  numberBtn: {
    width: '32px',
    height: '32px',
    border: '1px solid #d9d9d9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: '#fff',
    '&.left': {
      // borderRight: 'none'
    },
    '&.right': {
      // borderLeft: 'none'
    },
    '&:hover': {
      borderColor: '#1890ff',
      color: '#1890ff'
    }
  },
  numberInput: {
    width: '80px',
    height: '32px'
  },
  toolBtn: {
    width: '80px',
    height: '32px',
    border: '1px solid #d9d9d9',
    background: '#fff',
    textAlign: 'center',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  page: {
    margin: '0 20px',
  },
  greenText: {
    color: '#07AEA0'
  },
  space: {
    height: '32px',
    marginLeft: '20px',
    paddingLeft: '20px',
    borderLeft: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center'
  },
  kefu: {
    fontSize: '20px',
    cursor: 'pointer',
    '&:hover': {
      color: '#1890ff'
    }
  },
  uploadBtn: {
    margin: '0 40px 0 20px',
  },
  hideBtn: {
    fontSize: '20px',
    '&:hover': {
      color: '#1890ff'
    }
  },
  textBtn: {
    '&:hover': {
      color: '#1890ff'
    }
  },
  showBtn: {
    position: 'absolute',
    left: '50%',
    top: '-20px',
    fontSize: '20px',
    transform: 'translateX(-50%)',
    '&:hover': {
      color: '#1890ff'
    }
  },
  translateTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    marginBottom: '10px',
    color: 'rgba(0, 0, 0, 0.85)',
    '& .anticon': {
      marginRight: '16px'
    }
  },
  modalTip: {
    fontSize: '14px',
    color: '#666',
    lineHeight: '24px'
  },
  translateBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "440px",
    maxWidth: "90vw",
    padding: '32px 32px 24px',
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "6px",
  },
  flexBetween: {
    marginTop: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      width: '300px'
    }
  }
});

export default function Translate() {
  const classes = useStyles();

  let timer = ''

  const [fromUrl, setFromUrl] = useState('');
  const [toUrl, setToUrl] = useState('');
  const [twoFileUrl, setTwoFileUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showToolBar, setShowToolBar] = useState(true);
  const [checked, setChecked] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [showReBtn, setShowReBtn] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(1);
  const [scale, setScale] = useState(1);
  const [percent, setPercent] = useState('100%');
  const [translateFile, setTranslateFile] = useState({});

  const [loadToProgress, setLoadToProgress] = useState(0)
  const [showToProgress, setShowToProgress] = useState(true)
  const [loadFromProgress, setLoadFromProgress] = useState(0)
  const [showFromProgress, setShowFromProgress] = useState(true)


  const history = useHistory();

  useEffect(() => {
    initFile()
    
  }, []);
  
  useEffect(() => {
    if (!isInit) {
      setIsInit(true)
      let hideModal = localStorage.getItem('hideModal');
      if (!hideModal) {
        setShowModal(true)
      }
    }
  }, [])

  const initFile = () => {
    let file = sessionStorage.getItem('translateFile');
    let translatedFile = sessionStorage.getItem('translatedFile');
    let langTo = sessionStorage.getItem('langTo');
    let translateTwoLangFileUrl = sessionStorage.getItem('translateTwoLangFileUrl');
    if (file) {
      sessionStorage.setItem('translateFile', '');
      sessionStorage.setItem('translatedFile', '');
      sessionStorage.setItem('langTo', '');
      sessionStorage.setItem('translateTwoLangFileUrl', '')
      let fileObj = JSON.parse(file)
      setFromUrl(fileObj.dfs_url)
      setTranslateFile(fileObj)
      setTwoFileUrl(translateTwoLangFileUrl)
      if (translatedFile) { // 直接查看
        setToUrl(translatedFile)
      } else {
        // 创建翻译订单
        setLoading(true)
        createOrder({
          base_file_id: fileObj.base_file_id,
          order_target_language: langTo,
          order_type: '在线翻译'
        }).then(res => {
          if (res.order_id) {
            // 开始定时查询是否翻译结束
            timer = setTimeout(() => {
              checkResult(fileObj.base_file_id, res.order_id)
            }, 2000)
          } else {
            message.error('翻译失败')
            setShowReBtn(true)
          }
        })
      }
    }
  }

  const checkResult = (id, orderId) => {
    getFileStatus({
			base_file_id: id
    }).then(res => {
      let list = res.translated_file || []
      // let index = list.findIndex(v => {
      //   return orderId == v.translate_order_id
      // })
      if (res.translated_file.length > 0) {
        let file = res.translated_file[0]
        setLoading(false)
        setToUrl(file.mono_url || '')
			} else {
        timer = setTimeout(() => {
          checkResult(id, orderId)
        }, 2000)
      }
    })
  }
 

  const onDocumentLoadSuccess = (pdf) => {
    setTotal(pdf.numPages);
    // 计算缩放比例
    const containerWidth = document.getElementById('leftBox').offsetWidth;
    pdf.getPage(1).then(page => {
      const viewport = page.getViewport({ scale: 1 });
      const pdfWidth = viewport.width;
      const padding = 24; // 预留内边距
      const autoScale = (containerWidth - padding) / pdfWidth;
      let scale = Math.min(Math.max(autoScale, 0.5), 2.0)
      scale = Number((Math.ceil(scale * 10) / 10).toFixed(1))
      setScale(scale); // 限制缩放范围
      setPercent(`${parseInt(scale * 100)}%`);
    });
  };

  const onloadError = (e) => {
    console.log(123, e)
  }
  

  const items = [
    {
      label: '翻译件',
      key: '1',
    },
    {
      label: '双语翻译件',
      key: '2',
    },
  ];

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  }

  const nextPage = () => {
    if (pageNumber < total) {
      setPageNumber(pageNumber + 1);
    }
  }

  const minusScale = () => {
    console.log(123, scale)
    if (scale > 0.5) {
      let newScale = Number((scale - 0.1).toFixed(1))
      setScale(newScale);
      setPercent(`${parseInt(newScale * 100)}%`);
    }
  }

  const addScale = () => {
    if (scale < 2) {
      let newScale = Number((scale + 0.1).toFixed(1))
      setScale(newScale);
      setPercent(`${parseInt(newScale * 100)}%`);
    }
  }

  const closeModal = () => {
    setLoading(false)
    sessionStorage.setItem('toHistory', '1')
    history.push('/userCenter/translateLaw');
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  const doTranslate = () => {
    // 重新翻译
    handleClose()
    initFile()
  }

  // 下载
  const handleMenuClick = ({key}) => {
    let url = ''
    if (key == '1') { // 翻译件
      url = toUrl
    } else {// 双语翻译件
      url = twoFileUrl
    }
    let file_name = translateFile.file_name
    let name = file_name.substring(0, file_name.lastIndexOf('.'))
    let fileName = name + `-${key == '1' ? '翻译件' : '双语翻译件'}.pdf`
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  }

  // 加载进度更新时触发-源文件
  const onLoadToProgress = ({ loaded, total }) => {
    if (total) {
      const progress = Math.round((loaded / total) * 100);
      setLoadToProgress(progress);
      if (progress >= 100) {
        setShowToProgress(false)
      }
    }
  };
  // 加载进度更新时触发
  const onLoadFromProgress = ({ loaded, total }) => {
    if (total) {
      const progress = Math.round((loaded / total) * 100);
      setLoadFromProgress(progress);
      if (progress >= 100) {
        setShowFromProgress(false)
      }
    }
  };


  return (
    <Grid container className={classes.container}>
      <Grid container xs={12} className={classes.main}>
        <Grid item xs={6} className={classes.leftBox} id="leftBox">
          {
            showFromProgress && 
            <div className={classes.progress}>
              <Progress type="circle" percent={loadFromProgress} width={60}></Progress>
            </div>
          }
          {
            fromUrl && (
            <Document
              file={fromUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onloadError}
              onLoadProgress={onLoadFromProgress}
              options={{
                cMapUrl: '//unpkg.com/pdfjs-dist@3.4.120/cmaps/', // 解决中文显示问题
                cMapPacked: true,
              }}
              className={classes.pdfBox}
            >
              <Page 
                pageNumber={pageNumber} 
                scale={scale}
                className={classes.pdfMain}
              />
            </Document>
            )
          }
        </Grid>
        <Grid item xs={6} className={classes.rightBox}>
          {
            showToProgress && 
            <div className={classes.progress}>
              <Progress type="circle" percent={loadToProgress} width={60}></Progress>
            </div>
          }
          {
            toUrl ? 
            <Document
              file={toUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onloadError}
              onLoadProgress={onLoadToProgress}
              options={{
                cMapUrl: '//unpkg.com/pdfjs-dist@3.4.120/cmaps/', // 解决中文显示问题
                cMapPacked: true,
              }}
              className={classes.pdfBox}
            >
              <Page 
                pageNumber={pageNumber} 
                scale={scale}
                className={classes.pdfMain}
              />
            </Document>
            :
            <span>Loading PDF...</span>
          }
        </Grid>
      </Grid>

      <Grid className={[classes.toolbar, showToolBar ? 'show' : 'hide'].join(' ')}>
        <Button type="default" onClick={prevPage}>上一页</Button>
        <div className={classes.page}>
          <span className={classes.greenText}>{pageNumber}</span>
          <span>/{total}</span>
          </div>
        <Button type="default" onClick={nextPage}>下一页</Button>
        <div className={[classes.flexCenter, classes.space].join(' ')}>
          <div onClick={minusScale} className={[classes.numberBtn, 'left'].join(' ')}>
            <MinusOutlined />
          </div>
          <Input value={percent} readOnly className={classes.numberInput}></Input>
          <div onClick={addScale} className={[classes.numberBtn, 'right'].join(' ')}>
            <PlusOutlined />
          </div>
        </div>
        {/* <div className={classes.space}>
          <CustomerServiceOutlined className={classes.kefu} title="联系客服"/>
        </div> */}
        {
          showReBtn &&
          <div className={classes.space} >
            <Button type="text" onClick={() => setOpenModal(true)} className={classes.textBtn}>重新翻译</Button>
          </div>
        }
        <div className={classes.uploadBtn}>
          <Dropdown size="small"  menu={{ items, onClick: handleMenuClick }} placement="top" >
            <Button type="primary" >导出文件</Button>
          </Dropdown>
        </div>
        <div title="收起">
          <DownCircleOutlined className={classes.hideBtn} onClick={() => setShowToolBar(false)}/>
        </div>
        {
          !showToolBar && (
            <UpCircleOutlined className={classes.showBtn} onClick={() => setShowToolBar(true)}/>
          )
        }
      </Grid>

      <Modal
        open={loading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classes.translateBox}>
          <div className={classes.translateTitle}>
            <ExclamationCircleOutlined style={{color: '#faad14', fontSize: '22px'}} /> 提示
          </div>
          <div className={classes.modalTip}>正在翻译中，请稍后...</div>
          <div className={classes.modalTip}>您也可以稍后前往 个人中心-我的翻译 查看</div>
          <div className={classes.flexBetween}>
            <Button type="primary" onClick={closeModal}>关闭</Button>
          </div>
        </div>
      </Modal>

      <TranslateModal
        openModal={openModal}
        handleClose={handleClose}
        showFile={true}
        refresh={true}
        translateFile={translateFile}
        doTranslate={doTranslate}
        backTranslate={handleClose}
      ></TranslateModal>
    </Grid>
  );
}
